import React, {lazy, Suspense} from 'react';
import {BrowserRouter} from 'react-router-dom'
import {renderRoutes} from 'react-router-config'
import {Redirect} from "react-router";

import {Spin} from 'antd';
import {useSelector} from "react-redux";

const App = lazy(() => import('@/App'))
const Competition = lazy(() => import('@/views/Competition'))
const CompetitionAll = lazy(() => import('@/views/CompetitionSub/CompetitionAll'))
const CompetitionInfo = lazy(() => import('@/views/CompetitionSub/CompetitionInfo'))
const CompetitionCatalog = lazy(() => import('@/views/CompetitionSub/CompetitionCatalog'))
const CompetitionGuide = lazy(() => import('@/views/CompetitionSub/CompetitionGuide'))



const routes = [
  {
    path: "/",
    component: App,
    routes: [
      {
        path: "/",
        key: "App",
        exact: true,
        render: () => <Redirect to={"/competition/all"}/>
      },
      {
        path: "/competition",
        key: "Competition",
        component: Competition,
        routes: [
          {
            path: "/competition",
            key: "Competition",
            exact: true,
            render: () => <Redirect to={"/competition/all"}/>
          },
          {
            path: "/competition/all",
            component: CompetitionAll,
            key: "CompetitionAll",
          },
          {
            path: "/competition/info",
            component: CompetitionInfo,
            key: "CompetitionInfo",
          },
          {
            path: ["/competition/college", "/competition/base", "/competition/hot", "/competition/total"],
            component: CompetitionCatalog, // 替换为你的组件
            key: "CompetitionCatalog",
          },
          {
            path: "/competition/guide",
            component: CompetitionGuide,
            key: "CompetitionGuide",
          },
        ]
      }
    ]
  },
]
export const BasicRoute = () => {
  const state = useSelector((state: any) => state.store)
  console.log(state)
  return (
    <Suspense fallback={<Spin/>}>
      <BrowserRouter basename='/competition_community'>
        <Spin spinning={state.spin}>
          {renderRoutes(routes)}
        </Spin>
      
      </BrowserRouter>
    </Suspense>
  )
};